module.exports = __webpack_public_path__ + "static/media/PG.cde4bb4f.svg";